export const compliance = {
list: {
  chaseFailedBody: "Vérifiez votre connexion et réessayez. Si cela échoue encore, ouvrez le document et validez-le vous-même ou contactez directement le valideur.",
  chaseFailedTitle: "Rappel non envoyé",
  chaseSentBodyUnnamed: "Le valideur reçoit une notification pour le valider. Chacun reçoit au plus un rappel par jour.",
  chaseSentBody: "{{name}} reçoit une notification pour le valider. Chacun reçoit au plus un rappel par jour.",
  chaseSentTitle: "Rappel envoyé",
  showWorkspace: "Afficher tout l’espace de travail",
  noWorkspaceDescription: "La conformité s’affiche pour un espace de travail. Rejoignez-en un ou créez-le pour la voir ici.",
title: "Conformité",
subtitle_one: "{{count}} exigence",
subtitle_other: "{{count}} exigences",
searchPlaceholder: "Actifs, documents…",
searchA11y: "Rechercher dans la conformité",
refine: "Affiner",
refineSheetTitle: "Affiner la conformité",
clearFilters: "Effacer les filtres",
loadMore: "Charger plus",
emptyTitle: "Rien à prouver pour le moment",
emptyDescription: "Ouvrez un actif et ajoutez un certificat ou un autre document avec une date d’expiration. Il apparaîtra ici avec son échéance.",
emptyAction: "Aller aux actifs",
noMatchTitle: "Aucune exigence ne correspond",
noMatchDescription: "Aucune exigence de conformité ne correspond aux filtres que vous avez appliqués.",
errorTitle: "La conformité n'a pas pu être chargée",
unscopedTitle: "Choisissez un espace de travail",
unscopedDescription: "La conformité couvre tout l’espace de travail, et vous ne voyez que vos propres éléments. Touchez Afficher tout l’espace de travail.",
subtitle_many: "{{count}} exigences",
},
bucket: {
compliant: "OK",
expiring: "Expire bientôt",
overdue: "En retard",
invalid: "Rejeté",
pending: "En attente de validation",
missing_evidence: "Manquant",
unknown: "Inconnu",
},
bucketA11y: {
compliant_one: "{{count}} conforme",
compliant_many: "{{count}} conformes",
compliant_other: "{{count}} conformes",
expiring_one: "{{count}} expire bientôt",
expiring_many: "{{count}} expirent bientôt",
expiring_other: "{{count}} expirent bientôt",
overdue_one: "{{count}} en retard",
overdue_many: "{{count}} en retard",
overdue_other: "{{count}} en retard",
invalid_one: "{{count}} rejeté",
invalid_many: "{{count}} rejetés",
invalid_other: "{{count}} rejetés",
pending_one: "{{count}} en attente de validation",
pending_many: "{{count}} en attente de validation",
pending_other: "{{count}} en attente de validation",
missing_evidence: "Preuves manquantes : {{count}}",
unknown_one: "{{count}} inconnu",
unknown_many: "{{count}} inconnus",
unknown_other: "{{count}} inconnus",
},
state: {
overdue: "en retard",
overdueBy_one: "en retard de {{count}} jour",
overdueBy_other: "en retard de {{count}} jours",
expiring: "expire bientôt",
expiresToday: "expire aujourd'hui",
expiresIn_one: "expire dans {{count}} jour",
expiresIn_other: "expire dans {{count}} jours",
evidenceMissing: "preuve manquante",
rejected: "rejeté",
awaitingValidation: "en attente de validation",
nothingRecorded: "rien d'enregistré",
inDate: "à jour",
validFor_one: "valide pendant {{count}} jour",
validFor_other: "valide pendant {{count}} jours",
overdueBy_many: "en retard de {{count}} jours",
expiresIn_many: "expire dans {{count}} jours",
validFor_many: "valide pendant {{count}} jours",
},
action: {
upload_evidence: "Ajouter une preuve",
renew: "Renouveler",
replace_rejected: "Remplacer",
chase_validation: "Relancer le valideur",
record_expiry: "Ajouter une date d'expiration",
review_asset: "Examiner l'actif",
none: "",
schedule_inspection: "Inspecter",
},
row: {
responsible: "Responsable : {{name}}",
unassigned: "Aucun approbateur désigné",
sourceLocalRead: "Lu depuis le document",
sourceCloudAi: "Suggéré par l'IA",
sourceManual: "Saisi manuellement",
validatedBy: "Accepté par {{name}}",
openA11y: "Ouvrir {{label}} sur {{asset}}",
},
refine: {
status: "Statut",
site: "Site",
siteAny: "Tout site",
team: "Équipe",
teamAny: "Toute équipe",
assetType: "Type d'actif",
asset: "Actif",
requirement: "Exigence",
due: "Échéance",
dueAny: "Toute période",
due30: "30 prochains jours",
due90: "90 prochains jours",
sortBy: "Trier par",
groupBy: "Grouper par",
},
sort: {
due_soonest: "Échéance la plus proche",
severity: "Plus urgent",
asset_az: "Actif A-Z",
},
group: {
none: "Aucun groupement",
status: "Statut",
asset: "Actif",
site: "Site",
requirement: "Exigence",
noSite: "Aucun site",
noRequirement: "Rien de déclaré",
partialCount: "{{count}}+",
},
assetDetail: {
viewRegister: "Voir la conformité",
},
esg: {
loading: "Chargement des chiffres ESG…",
loadFailed: "Impossible de charger les chiffres ESG.",
retry: "Réessayer",
notCoveredTitle: "L'ESG n'est pas activé pour ce site",
notCoveredBody: "Votre espace de travail a l'ESG sur certains sites seulement. Un administrateur peut ajouter ce site dans Offre et facturation.",
noMetersTitle: "Pas encore de relevés d'énergie",
noMetersBody: "Ajoutez un compteur (électricité, gaz, fioul, chaleur ou eau) à un équipement et saisissez des relevés. L'énergie et le carbone apparaissent ici le lendemain, ou tout de suite avec Actualiser.",
byFuelTitle: "Énergie par source (12 derniers mois)",
byMonthTitle: "Énergie par mois",
byMonthA11y: "Graphique en barres de l'énergie consommée chaque mois sur les 12 derniers mois",
unconverted: "Certains relevés utilisent une unité impossible à convertir en kWh et sont ignorés. Vérifiez l'unité du compteur.",
estimateNote: "Le carbone est une estimation selon les facteurs de conversion du gouvernement britannique ({{year}}). Le scope 1 est le combustible brûlé sur site ; le scope 2 l'électricité achetée.",
updatedAt: "Chiffres calculés {{when}}",
notYetComputed: "Pas encore calculé. Touchez Actualiser.",
refresh: "Actualiser",
guideMe: "Guidez-moi",
refreshing: "Actualisation…",
edit: "Modifier",
save: "Enregistrer",
cancel: "Annuler",
remove: "Retirer",
saveFailed: "Enregistrement impossible. Vérifiez votre connexion et réessayez.",
floorAreaTitle: "Surface",
floorAreaLabel: "Surface (m²)",
floorAreaHint: "Sert à l'énergie et au carbone par m². N'incluez les sites internes que s'ils n'ont pas leur propre surface.",
floorAreaInvalid: "Saisissez un nombre de mètres carrés.",
floorAreaValue: "Surface : {{m2}} m²",
kpi: {
energy: "Énergie",
carbon: "Carbone",
intensity: "kWh par m²",
intensityUnit: "12 derniers mois",
needsFloorArea: "Ajoutez la surface",
meters: "Compteurs relevés",
metersHint: "relevés dans les 3 derniers mois",
water: "Eau",
vsLastYear: "{{change}} par rapport à l'année précédente",
last12m: "12 derniers mois",
scopes: "Scope 1 : {{s1}} · Scope 2 : {{s2}}",
      same: "Inchangé",
      lower: "↓ {{pct}} %",
      higher: "↑ {{pct}} %",
      electricity: "Électricité",
      electricityCarbon: "{{tonnes}} t CO₂e, 12 derniers mois",
      refrigerant: "Fluide frigorigène",
      refrigerantGwp: "{{refrigerant}}, PRG {{gwp}}",
      fgasSize: "Quantité de gaz fluorés",
      fgasFormula: "{{kg}} kg × PRG {{gwp}}",
      fgasUnknownGwp: "PRG inconnu pour ce gaz",
      leaked: "Fuites, 12 derniers mois",
      leakedTonnes: "{{tonnes}} t CO₂e de fuites",
      carbonCaption: "par rapport à l’an dernier, estimation",
      vsLastYearShort: "par rapport à l’an dernier",
      perM2: "Énergie par m²",
      perM2Caption: "12 derniers mois",
      allFuels: "toutes énergies, 12 derniers mois",
},
fuel: {
electricity: "Électricité",
gas: "Gaz",
heat: "Chaleur",
oil: "Fioul",
water: "Eau",
},
refrigerant: {
title: "Fluide frigorigène (gaz fluorés)",
none: "Aucun fluide frigorigène enregistré.",
add: "Ajouter un fluide",
summary_one: "{{count}} équipement contient {{tonnes}} t CO₂e de fluide ; {{inBand}} nécessitent un contrôle d'étanchéité.",
summary_other: "{{count}} équipements contiennent {{tonnes}} t CO₂e de fluide ; {{inBand}} nécessitent un contrôle d'étanchéité.",
summary_many: "{{count}} équipements contiennent {{tonnes}} t CO₂e de fluide ; {{inBand}} nécessitent un contrôle d'étanchéité.",
overdue_one: "{{count}} contrôle d'étanchéité est en retard.",
overdue_other: "{{count}} contrôles d'étanchéité sont en retard.",
overdue_many: "{{count}} contrôles d'étanchéité sont en retard.",
assetLine: "{{refrigerant}}, {{kg}} kg ({{tonnes}} t éq. CO₂)",
checkEvery: "Contrôle d'étanchéité tous les {{months}} mois. Prochain le {{next}}.",
noCheckNeeded: "Sous le seuil des gaz fluorés : pas de contrôle régulier.",
leakDetectionRequired: "À cette taille, la réglementation exige un système de détection des fuites.",
added12m: "{{kg}} kg ajoutés sur les 12 derniers mois",
typeLabel: "Fluide",
chargeLabel: "Charge en fluide (kg)",
chargeInvalid: "Saisissez la charge en kg.",
leakDetection: "Détection des fuites installée",
hermetic: "Hermétiquement scellé",
previewBand: "{{tonnes}} t CO₂e : contrôle tous les {{months}} mois.",
previewNone: "{{tonnes}} t CO₂e : pas de contrôle régulier.",
planNote: "Nous ajoutons le contrôle d'étanchéité au plan de cet équipement et gardons le bon intervalle.",
logCheck: "Saisir un contrôle",
logLeak: "Saisir une fuite",
logTopUp: "Saisir un appoint",
logRecovered: "Saisir une récupération",
kgLabel: "Quantité (kg)",
removeTitle: "Retirer le fluide ?",
removeBody: "Le plan de contrôle de cet équipement prend fin. L'historique des contrôles est conservé.",
      edit: "Modifier le fluide",
      fromDetails: "Gaz issu des détails de l’équipement : {{refrigerant}}",
},
epc: {
title: "Certificats énergétiques",
none: "Aucun certificat enregistré.",
add: "Ajouter un certificat",
ratingLabel: "Classe",
validUntilLabel: "Valable jusqu'au (AAAA-MM-JJ)",
validUntil: "valable jusqu'au {{date}}",
dateInvalid: "Saisissez la date au format AAAA-MM-JJ.",
refLabel: "Numéro du certificat",
isLet: "Le bâtiment est loué",
belowMinimum: "Sous E : un bâtiment loué en Angleterre et au pays de Galles ne peut pas être loué avec cette classe sans dérogation.",
expired: "Expiré",
expiresSoon: "Expire dans moins de 6 mois",
documentNote: "Rangez le certificat dans Documents comme Certificat de performance énergétique pour être prévenu avant son expiration.",
removeTitle: "Retirer ce certificat ?",
      let: "Loué",
      notLet: "Non loué",
      meetsStandard: "Respecte le minimum pour louer",
      open: "Ouvrir le certificat",
      attachFile: "Joindre le fichier",
      noFile: "Aucun fichier joint",
      addRating: "Ajouter la classe",
      keptInDocuments: "Les certificats sont classés une seule fois, dans Documents. La classe, la date et le rappel viennent de là.",
},
sg: {
title: "Social et gouvernance",
hint: "D'après vos inspections et interventions des 12 derniers mois.",
compliance: "Conformité",
risk: "Risque moyen",
inspections: "Inspections",
signedOff: "{{done}} faites, {{signed}} validées",
jobs: "Interventions",
rework: "{{done}} faites, {{rework}} reprises",
contractors: "Prestataires sollicités",
      tile: {
        contractors: "Prestataires intervenus",
        contractorsCaption: "assurance pas encore enregistrée",
        safety: "Certificats de sécurité valides",
        findings: "Constats corrigés à temps",
        signedOff: "Travaux planifiés validés",
        ofCount: "{{done}} sur {{total}}",
        nothingYet: "rien à compter pour l’instant",
      },
},
promptTitle: "ESG et développement durable",
promptBody: "Énergie, carbone, fluides frigorigènes et certificats énergétiques pour chaque site et équipement, calculés à partir des relevés que vous faites déjà. Une option facturée par équipement.",
promptAction: "L'ajouter dans Offre et facturation",
promptAskAdmin: "Demandez à un administrateur de l'ajouter.",
promptNotInApp: "Achat impossible dans l'application.",
ai: {
title: "Rédiger une synthèse",
hint: "Une courte synthèse de ces chiffres avec des actions recommandées. Chaque nombre vient d'au-dessus.",
reader: {
manager: "Pour moi",
landlord: "Pour un bailleur",
investor: "Pour un investisseur",
},
write: "Rédiger une synthèse",
again: "Rédiger à nouveau",
writing: "Rédaction…",
failed: "Rédaction impossible. Réessayez.",
noCredits: "Votre espace de travail n'a plus de crédits IA.",
plainNote: "Synthèse simple, aucun crédit IA utilisé.",
actionsTitle: "Actions recommandées",
do: {
job: "Créer une intervention",
inspection: "Inspecter",
reading: "Ajouter un relevé",
record: "Ouvrir",
},
},
portfolio: {
title: "ESG du patrimoine",
hint: "Chaque site principal, 12 derniers mois.",
site: "Site",
energy: "Énergie",
change: "Évolution",
intensity: "kWh par m²",
carbon: "Carbone",
epc: "DPE",
fgas: "Gaz F",
overdue: "en retard",
belowMinimum: "sous E",
expiring: "expire",
empty: "Pas encore de sites.",
workspaceTitle: "Tout l'espace de travail",
},
    period: "De {{from}} à {{to}}",
    addFloorArea: "Ajouter la surface",
    addonBadge: "Module ESG",
    promptTitleAsset: "ESG de cet équipement",
    promptTitleSite: "ESG de ce site",
    promptMeters_one: "Vous relevez déjà {{count}} compteur ici ({{kinds}}). Avec le module ESG, ses relevés deviennent aussitôt des chiffres d’énergie, de carbone et de comparaison annuelle.",
    promptMeters_many: "Vous relevez déjà {{count}} compteurs ici ({{kinds}}). Avec le module ESG, leurs relevés deviennent aussitôt des chiffres d’énergie, de carbone et de comparaison annuelle.",
    promptMeters_other: "Vous relevez déjà {{count}} compteurs ici ({{kinds}}). Avec le module ESG, leurs relevés deviennent aussitôt des chiffres d’énergie, de carbone et de comparaison annuelle.",
    promptNothingHidden: "Rien de ce que vous saisissez n’est masqué ni perdu : compteurs, relevés et documents restent tels quels.",
    header: {
      floorArea: "{{value}} m² de surface",
      rating: "Classe {{scheme}} {{rating}}",
    },
    csv: {
      defaultName: "Données ESG",
    },
    actions: {
      exportCsv: "Exporter le CSV ESG",
      share: "Partager le rapport ESG",
      openAsset360: "Ouvrir Équipement 360",
      openSite360: "Ouvrir Site 360",
    },
    chart: {
      electricityTitle: "Électricité par mois",
      energyTitle: "Énergie par mois",
      subElectricity_one: "MWh, de {{count}} compteur",
      subElectricity_many: "MWh, de {{count}} compteurs",
      subElectricity_other: "MWh, de {{count}} compteurs",
      subEnergy_one: "MWh, toutes énergies, de {{count}} compteur",
      subEnergy_many: "MWh, toutes énergies, de {{count}} compteurs",
      subEnergy_other: "MWh, toutes énergies, de {{count}} compteurs",
      a11y: "{{title}} : une barre pour chacun des 12 derniers mois et une ligne pointillée pour le même mois l’an dernier",
      valueWithLastYear: "{{month}} : {{value}} MWh (l’an dernier {{last}} MWh)",
      value: "{{month}} : {{value}} MWh consommés",
      tapHint: "Touchez une barre pour voir sa valeur.",
      thisYear: "Cette année",
      lastYear: "L’an dernier",
      metersReporting: "{{reporting}} compteurs sur {{total}} relevés (dans les 3 derniers mois)",
    },
    carbon: {
      title: "D’où vient le carbone",
      sub: "12 derniers mois, estimation avec les facteurs {{year}}",
      scope: "Périmètre {{n}}",
      refrigerantLeak: "Fuite de fluide, {{name}}",
      none: "Aucun carbone calculé pour l’instant. Ajoutez des relevés de compteur ou des recharges de fluide.",
      fuelsTitle: "Énergie par source",
    },
    fgas: {
      titleWithEpc: "Gaz fluorés et certificats énergétiques",
      none: "Aucun fluide frigorigène enregistré sur ce site.",
      row: "{{name}} : {{refrigerant}}, {{kg}} kg ({{tonnes}} t CO₂e)",
      overdue: "Contrôle d’étanchéité en retard",
      due: "Contrôle d’étanchéité le {{date}}",
      noCheck: "Aucun contrôle d’étanchéité requis",
      openJobFor: "Ouvrir l’intervention de {{name}}",
      bookFor: "Planifier le contrôle de {{name}}",
      jobTitle: "Contrôle d’étanchéité gaz fluorés : {{name}}",
      jobDescription: "Contrôle d’étanchéité du système au {{refrigerant}} ({{kg}} kg, {{tonnes}} t CO₂e) par un technicien certifié. Notez le résultat et le fluide ajouté.",
    },
    leak: {
      title: "Contrôles d’étanchéité",
      sub: "La fréquence de contrôle exigée par les règles sur les gaz fluorés, selon la quantité en t CO₂e.",
      every: "Tous les {{months}} mois",
      noneNeeded: "Non requis",
      band: {
        none: "Moins de 5 t",
        "5-50": "De 5 à 50 t",
        "50-500": "De 50 à 500 t",
        "500+": "500 t et plus",
      },
      lastCheck: "Dernier contrôle le {{date}} : {{result}}",
      resultLeak: "fuite trouvée",
      resultPassed: "réussi",
      noCheckYet: "Aucun contrôle d’étanchéité enregistré.",
      overdue: "En retard depuis le {{date}}",
      nextDue: "Prochain le {{date}}",
      openJob: "Ouvrir l’intervention",
      logTitle: "Journal des fuites",
      logEmpty: "Rien d’enregistré pour l’instant.",
      event: {
        leak_check: "Contrôle d’étanchéité",
        leak_found: "Fuite trouvée",
        top_up: "Recharge de {{kg}} kg",
        recovered: "{{kg}} kg récupérés",
      },
      showFewer: "Afficher moins",
      seeAll: "Voir les {{total}}",
      callout: "Chaque recharge compte comme une fuite : ses kg × PRG s’ajoutent au carbone du périmètre 1.",
    },
    units: {
      mwh: "{{value}} MWh",
      kwh: "{{value}} kWh",
      kg: "{{value}} kg",
      t: "{{value}} t",
      mwhAxis: "MWh",
    },
},
};
